import Vue from 'vue'
import to from 'await-to-js'
import client from '@/api/client'
import HOMEPAGE_QUERY from '@/api/gql/homepage/query/homepage.gql'

const DEFAULT_TEMPLATE = 'C'

const getCategorySliderData = vm => {
  // TODO: #3581 ⁃ Provide category slider data via GraphQl
  // TODO: #3407 ⁃ Add final hard-coded data for category slider
  const getFullUrl = vm.$store.getters['page/getFullUrl']
  const ctaText = vm.$t('discover_cta')
  const CATEGORY_SLIDER_DATA = [
    {
      title: vm.$t('latest'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/66dAM1h91LpiNJHewiTVfh/b020d4f62bdf27f9d5e608b6fce64cfb/category_slider-fw22-new_arrivals.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?release_date=new-arrivals') }],
    },

    {
      title: vm.$t('the_roger_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/39MDh1HBDpZiqELeQr20m2/5f528a809ca63c46b275a284ba46c0f1/category_slider-fw22-theroger_collection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/roger') }],
    },

    {
      title: vm.$t('shoe_finder'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/2MgG2TXnFQD2PdZWMORAMe/619be1902fcaf3a7c8862e18e9bbcd80/category_slider-fw22-shoe_finder.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/shoe-finder') }],
    },

    {
      title: vm.$t('road_running'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/5Kkcs7N8roDebQtRYKOge3/7b28315b87a4d5aa41250d7c886a1231/category_slider-fw22-running_shoes.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/shoes/road') }],
    },

    {
      title: vm.$t('apparel'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/BktzLYAXiY6wguO9bQxxu/06778f8add3b57657c9343bc032f688d/category_slider-fw22-apparel.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/apparel') }],
    },

    {
      title: vm.$t('cloud_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/6Lz4FtTf0OVD5dcGZlrTEb/2bdd254892ea0a8e51c67b5be1fdf923/category_slider-fw22-cloud_collection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/cloud') }],
    },

    {
      title: vm.$t('accessories'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/624e443ZA3rdxt54uUM4sI/081c52d339c763aba877b2312eaac8b9/category_slider-fw22-accessories.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/accessories') }],
    },

    {
      title: vm.$t('home_workout'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/6kMq6DzQkRZh9cD6zkNGgr/5f60847ba95b963e4e55278085313125/category_slider-fw22-workout.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/homeworkout') }],
    },

    {
      title: vm.$t('bestsellers'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/35MLE66qNq29dKd4P31MSX/0f2ff0b98e2d1565f46df3300b360db2/category_slider-fw22-best_sellers.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/explore/?sort=bestseller') }],
    },

    {
      title: vm.$t('outdoor_collection'),
      backgroundImage: {
        desktop:
          'https://images.ctfassets.net/od02wyo8cgm5/49MDCy7dzKt5EPFKJ9u7yZ/997b4a9637e5c981cbba44c16578e235/category_slider-fw22-outdoor_collection.jpg',
      },
      ctas: [{ text: ctaText, url: getFullUrl('/collection/outdoor') }],
    },
  ]

  return CATEGORY_SLIDER_DATA
}

const HomepageService = {
  async fetch(vm) {
    const [error, result] = await to(client.query({ query: HOMEPAGE_QUERY }))
    if (error) Vue.rollbar.error(error.message, error)
    const homepage = result?.data?.homepage || {}
    if (!homepage.template) homepage.template = DEFAULT_TEMPLATE
    return {
      ...homepage,
      categorySlider: getCategorySliderData(vm, homepage.template),
    }
  },
}

export default HomepageService
